import { render } from "./outro.vue?vue&type=template&id=62317708&scoped=true"
import script from "./outro.vue?vue&type=script&lang=js"
export * from "./outro.vue?vue&type=script&lang=js"

import "./outro.vue?vue&type=style&index=0&id=62317708&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62317708"]])

export default __exports__